import type { DirectoryEditSchemaEditPayload } from '@repo/schemas/directory/directoryEdit';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { DirectoryService } from './directoryService';
import { DirectoryKey } from './keys';

export const useEditDirectory = (directoryId?: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: DirectoryEditSchemaEditPayload) => DirectoryService.editDirectory(data).then((response) => response.data),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [DirectoryKey.DIRECTORY, directoryId],
      });
      if (variables.permissionChanges) {
        queryClient.invalidateQueries({
          queryKey: [DirectoryKey.DIRECTORY_PERMISSIONS, data.id],
        });
      }
    },
  });
};
